<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <el-form-item>
          <el-input
            v-model="dataForm.keyword"
            :placeholder="kwPlaceHolder"
            class="wd500 input-with-select-lg"
            :class="{ hideInputActive: dataForm.noClientCodeInQuotation || dataForm.noLinkedEngagement }"
            v-regexFilter="halfWidthRegex"
          >
            <el-select v-model="dataForm.kwType" slot="prepend" placeholder="please select" @change="kwTypeChange">
              <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.country" multiple clearable placeholder="Country of Company">
            <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.coordinatorIds" placeholder="select coordinator" multiple clearable>
            <el-option label="Unassigned" :value="-1"></el-option>
            <el-option v-for="item in userList" :key="item.value" :label="item.nickname || item.username" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.auditorIds" placeholder="select reviewer" multiple clearable>
            <el-option label="Unassigned" :value="-1"></el-option>
            <el-option v-for="item in userList" :key="item.value" :label="item.nickname || item.username" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select-all
            :optionList="applymentStatusExcludeDraftList"
            placeholder="Status"
            @elSelectAllChange="
              list => {
                dataForm.applymentStatus = list;
              }
            "
          ></el-select-all>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.businessGenre" clearable placeholder="Entity Type">
            <el-option v-for="item in entityTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isForfeited" clearable placeholder="Active Status">
            <el-option label="Active" :value="false"></el-option>
            <el-option label="In-active" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
            <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 列表 -->
    <div>
      <el-table
        max-height="660"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'inquiryTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="applymentNo" align="center" label="Quotation No." fixed="left" width="130" />
        <el-table-column align="center" label="Supplier" fixed="left" width="200">
          <template slot-scope="scope">
            <p>{{ supplierAbbrDeduplicateFormat(scope.row.supplierList) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="inquiryTime" align="center" label="First Request Time" width="180" sortable="custom" />
        <el-table-column prop="latestInquiryTime" align="center" label="Latest Remind Time" width="160" />
        <el-table-column align="center" label="Client Code" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.quotationList?.length > 0">{{ clientCodeDeduplicateFormat(scope.row.quotationList) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="applymentStatus" align="center" label="Status" width="200">
          <template slot-scope="scope">
            <p>{{ applymentStatusFormat(scope.row.applymentStatus) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Linked Engagement ID" width="184">
          <template slot-scope="scope">
            <span v-if="scope.row.engagementList?.length > 0">{{ engagementIdDeduplicateFormat(scope.row.engagementList) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Entity Name" width="360">
          <template slot-scope="scope">
            <div v-for="(name, index) in proposedCompanyNameFormat(scope.row)" :key="`entityName-${scope.row.id}-${index}`">
              {{ name }}
            </div>
            <div v-if="scope.row?.fundInfoList?.length > 0">
              {{ scope.row.fundInfoList.map(item => item.fundName)?.join(", ") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="businessGenre" align="center" label="Entity Type" width="160">
          <template slot-scope="scope">
            <p>{{ entityTypeFormat(scope.row.businessGenre) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="applicantName" align="center" label="Applicant Name" width="140" />
        <el-table-column prop="applicantEmail" align="center" label="Applicant Email" width="180" />
        <el-table-column prop="country" align="center" label="Country of Company" width="180" />
        <el-table-column prop="coordinator" align="center" label="Coordinator" width="180" :formatter="operatorStaffFormat" />
        <el-table-column prop="auditor" align="center" label="Reviewer" width="180" :formatter="operatorStaffFormat" />
        <el-table-column align="center" label="Action" fixed="right" width="110">
          <template slot-scope="scope">
            <el-button @click="detailHandler(scope.row.id)" type="text" class="fwb">Detail</el-button>
            <!-- 禁用 -->
            <el-button
              v-if="isAuth('quotation:forfeit') && !scope.row.hasPaid && scope.row.applymentStatus != 'FORFEITED'"
              type="text"
              class="fwb ml0"
              @click="statusUpdateHandle(scope.row, 'Forfeit')"
            >
              Forfeit
            </el-button>
            <!-- 启用 -->
            <el-button
              v-if="isAuth('quotation:reActive') && !scope.row.hasPaid && scope.row.applymentStatus == 'FORFEITED'"
              type="text"
              class="fwb ml0"
              @click="statusUpdateHandle(scope.row, 'Re-active')"
            >
              Re-active
            </el-button>
            <!-- 重新报价 -->
            <template v-if="['QUOTATION_AUDITING', 'QUOTATION_AUDIT_PASS', 'QUOTATION_AUDIT_FAIL', 'SUBMITTED'].includes(scope.row.applymentStatus)">
              <!-- 未收款(hasPaid == 0)，才可以重新报价 -->
              <template v-if="scope.row.hasPaid == 0">
                <el-button v-if="isAuth('quotation:requote')" type="text" class="fwb ml0" @click="requoteHandle(scope.row)">Requote</el-button>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </div>
</template>

<script>
import ElSelectAll from "@/components/ElSelectAll";
import Pagination from "@/components/Pagination";
import searchMixin from "@/mixins/searchMixin";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, paginationMixin, tableMixin, formatterMixin],
  components: {
    ElSelectAll,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      dataListLoading: false,
      kwTypes: [
        {
          title: "Quotation No.",
          value: "applymentNo",
          placeholder: "Quotation No.",
        },
        {
          title: "Applicant",
          value: "applicant",
          placeholder: "Applicant Name Or Applicant Email",
        },
        {
          title: "Entity Name",
          value: "companyName",
          placeholder: "Entity Name",
        },
        {
          title: "Client Code Blank",
          value: "clientCodeBlank",
          placeholder: "",
        },
        {
          title: "Linked Engagement ID Blank",
          value: "linkedEngagementIdBlank",
          placeholder: "",
        },
      ],
      dataForm: {
        kwType: "applymentNo",
        keyword: "",
        applymentNo: "",
        applicant: "",
        companyName: "",
        fundsName: "",
        coordinatorIds: "",
        auditorIds: "",
        startTime: null,
        endTime: null,
        applymentStatus: "",
        businessGenre: "",
        isForfeited: null,
        supplierId: "",
        noClientCodeInQuotation: null,
        noLinkedEngagement: null,
        "orders[0].asc": false,
        "orders[0].column": "t1.inquiry_time",
        businessTypes: ["COMPREHENSIVE_CUSTOMIZED", "FUND_ADMIN_CUSTOMIZED"],
      },
      userList: [],
      supplierList: [],
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "entityTypes"]),
  },
  methods: {
    // kwType下拉框 - change
    kwTypeChange() {
      if (this.dataForm.kwType == "clientCodeBlank") {
        this.dataForm.keyword = "";
        this.dataForm.noClientCodeInQuotation = true;
      } else {
        this.dataForm.noClientCodeInQuotation = null;
      }
      if (this.dataForm.kwType == "linkedEngagementIdBlank") {
        this.dataForm.keyword = "";
        this.dataForm.noLinkedEngagement = true;
      } else {
        this.dataForm.noLinkedEngagement = null;
      }
    },
    //用户列表
    async getSysUserList() {
      const { data } = await this.$http.get(`/admin/sysUser/getList`);
      this.userList = data;
    },
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 申请单状态
    handleApplymentStatusChange() {
      this.getDataList(1);
    },
    handleCountryChange() {
      this.getDataList(1);
    },
    // 详情
    detailHandler(id) {
      this.$router.push(`/quotation/${id}`);
    },
    // 获取数据列表
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const { code, data } = await this.$http.get("/admin/companyApplymentManage/paging", {
        params: {
          current: this.current,
          size: this.pageSize,
          // "orders[0].asc": false,
          // "orders[0].column": "id",
          ...this.dataForm,
          sourceFlag: 2,
          [this.dataForm.kwType]: this.dataForm.keyword,
        },
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 禁用、启用
    async statusUpdateHandle(row, tipe) {
      await this.$confirm(`${tipe} This Quotation. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http
        .post(`/admin/companyApplymentStatusManage/${tipe == "Forfeit" ? "forfeit" : "reActive"}`, {
          applymentId: row.id,
        })
        .then(res => {
          this.$message.success("success");
          this.getDataList();
        })
        .catch(err => {});
    },
    // 重新报价
    async requoteHandle(data) {
      await this.$confirm("Requote This Quotation. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      // 重新报价时，需要将lastStayPage固定到前台的"服务报价单(quotation)"页，1或3都是"服务报价单(quotation)"页的页码
      // isLaterService为true时，代表该申请单是业务人员在前台进行了"增加服务"操作，需要跳过用户填写问卷和资料页，所以lastStayPage固定为1
      this.$http
        .post("/admin/companyApplymentStatusManage/repOpenQuotation", {
          applymentId: data.id,
          lastStayPage: data.isLaterService ? 1 : 3,
        })
        .then(res => {
          this.$message.success("success");
          this.getDataList();
        })
        .catch(err => {});
    },
  },
  activated() {
    this.getSysUserList();
    this.getSupplierList();
    this.getDataList();
  },
};
</script>

<style lang="scss" scoped>
.company-name-tag {
  display: inline-flex;
  flex-direction: column;
}

.hideInputActive {
  width: 200px !important;
  border-right: 1px solid #dcdfe6;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;

  ::v-deep .el-input-group__prepend + .el-input__inner {
    display: none;
  }
}
</style>
